import { cloneElement, isValidElement } from "react";
import { useCmsPageByCode } from "@/features/shop/cms/hooks/useCmsPageByCode";
import { parseSearchBarPayload } from "@/features/shop/cms/utils/searchBarPayloadTransformer";
import { SearchBarSection } from "@/features/shop/components/SearchBar/SearchBarSection";

const DEFAULT_TITLE = "Que recherchez-vous ?";
const DEFAULT_PLACEHOLDER = "Rechercher un produit, un billet, mes prochaines vacances ...";

export type CmsSearchBarSectionProps = {
  pageCode: string
  children: React.ReactNode
};

export const CmsSearchBarSection = ({
  pageCode,
  children,
}: CmsSearchBarSectionProps) => {
  const { data: cmsPageDetail, isLoading, isError } = useCmsPageByCode({
    code: pageCode,
    enabled: !!pageCode,
  });

  if (isLoading || isError || !cmsPageDetail) {
    return <SearchBarSection>{children}</SearchBarSection>;
  }

  const searchZone = cmsPageDetail.zones.find((zone) => zone.code.toLowerCase().startsWith("search"));

  if (!searchZone || searchZone.blocks.length === 0) {
    return <SearchBarSection>{children}</SearchBarSection>;
  }

  const block = searchZone.blocks[0];
  const payload = parseSearchBarPayload(block.payload);

  const title = block.title || DEFAULT_TITLE;
  const placeholder = block.subtitle || DEFAULT_PLACEHOLDER;

  const childrenWithPlaceholder = isValidElement(children)
    ? cloneElement(children, { placeholder } as Record<string, unknown>)
    : children;

  return (
    <SearchBarSection
      title={title}
      yeatiImageUrl={block.media_url}
      animationConfig={payload.animation}
      gradientColors={payload.gradientColors}
    >
      {childrenWithPlaceholder}
    </SearchBarSection>
  );
};
